import {
  Component,
  ElementRef,
  Renderer2,
  DoCheck,
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef, Input, forwardRef
} from '@angular/core';
import { BASE_LAYOUT, WizBaseLayout } from '../../core/wiz-base-layout';

/**
 * Groupe affichant ses enfants sans alignement enter eux
 */
@Component({
  selector: 'wiz-group',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./wiz-group.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: BASE_LAYOUT, useExisting: forwardRef(() => WizGroup)},
    {provide: WizBaseLayout, useExisting: forwardRef(() => WizGroup)},
  ]
})
export class WizGroup extends WizBaseLayout implements AfterContentChecked, DoCheck {
  constructor(elementRef: ElementRef, renderer: Renderer2, cdref: ChangeDetectorRef) {
    super(elementRef, renderer, cdref);
  }

  /** positionnement manuel des enfants : pas de gestion de l'updateChildren */
  private _customStaging: boolean = false;
  @Input()
  public set customStaging(value: boolean) {
    this._customStaging = value;
  }
  public get customStaging(): boolean {
    return this._customStaging;
  }


  ngAfterContentChecked(): void {
    this.ngDoCheck();
  }

  /*
   * Détection de l'injection de composants enfants
   */
  ngDoCheck(): void {
    // Check si le nombre d'enfants a changé
    if (this.children && this.children.length !== this.numChildren) {
      this.numChildren = this.children.length;
      // Positionnement des enfants
      const childrens: any[] = this.elementRef.nativeElement.children;

      let idx: number = 0;
      for (const element of childrens) {
        // Les enfants en position absolue et on superpose
        this.renderer.setStyle(element, 'position' ,  'absolute');
        this.renderer.setStyle(element, 'z-index' ,  idx);
        this.updateChildrenPosition();
        idx++;
      }
    }
  }

  /** Alignement horizontal des éléments enfants */
  @Input() set horizontalAlign(horizontalAlign: 'start' | 'center' | 'end' ) {
    this._horizontalAlign = horizontalAlign;
    this.updateChildrenPosition();
  }

  /** Alignement vertical des éléments enfants */
  @Input() set verticalAlign(verticalAlign: 'start' | 'center' | 'end') {
    this._verticalAlign = verticalAlign;
    this.updateChildrenPosition();
  }

  /**
   * Place les enfants dans le group en fonction des horizontalAlign et verticalAlign
   */
  private updateChildrenPosition() {

    if (this.customStaging) {
      return;
    }

    const childrens: any[] = this.elementRef.nativeElement.children;

    // init ou remise a zero des positions
    let horizontalTranslate = '0%';
    let verticalTranslate = '0%';
    let position: {left: string; right: string; top: string; bottom: string; };
    position = {left: 'auto', right: 'auto', top: 'auto', bottom: 'auto' };


    // calcul de la position horizontale des composants
    if (this._horizontalAlign === 'center') {
      position.left = '50%';
      horizontalTranslate = '-50%';
    } else if (this._horizontalAlign === 'start') {
      position.left = '0';
      horizontalTranslate = '0%';
    } else if (this._horizontalAlign === 'end') {
      position.right = '0';
    }

    // calcul de la position verticale des composants
    if (this._verticalAlign === 'center') {
      position.top = '50%';
      verticalTranslate = '-50%';
    } else if (this._verticalAlign === 'start') {
      position.top = '0';
    } else if (this._verticalAlign === 'end') {
      position.bottom = '0';
    }


    // détermine la position
    for (const element of childrens) {
      // applique le style à l'élément
      this.renderer.setStyle(element, 'left', position.left);
      this.renderer.setStyle(element, 'right', position.right);
      this.renderer.setStyle(element, 'top', position.top);
      this.renderer.setStyle(element, 'bottom', position.bottom);
      this.renderer.setStyle(element, 'transform', 'translate(' + horizontalTranslate + ',' + verticalTranslate + ')');
    }
  }
}

